import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AddIcon } from 'assets/icon-add-round.svg';
import { Button } from 'shared/components/Buttons';

import { ActionBarWrapper } from './styles';

const ActionBar = ({ onNewFolder }) => {
  const { t } = useTranslation();
  return (
    <ActionBarWrapper>
      <div className="w-100 container-actions">
        <div className="d-flex flex-row justify-content-start align-items-center remove-padding-horizontal">
          <Button
            className="add-button"
            type="button"
            color="secondary"
            label={t('custom_folder_create_folder')}
            icon={<AddIcon />}
            onClick={onNewFolder}
          />
        </div>
      </div>
    </ActionBarWrapper>
  );
};

ActionBar.defaultProps = {};

ActionBar.propTypes = {
  onNewFolder: PropTypes.func.isRequired,
};

export default ActionBar;
